import { Grid, styled } from '@mui/material';
import React, { Fragment, useMemo, useState } from 'react';
import MatxLoading from "../../../components/MatxLoading";
import useOrders from "../../../hooks/orders/useOrders";
import OrderDetailTopCards from "../components/OrderDetailTopCards";
import OrderItemsCards from "../components/OrderItemsCards";
import { H4 } from "../../../components/Typography";
import OrderSummeryCard from "../components/OrderSummeryCard";
import OrderRiderSearchHistory from "../components/OrderRiderSearchHistory";

import { useParams } from "react-router-dom";
import { OrderProvider } from '../orderStore';
import OrderStatus from '../components/OrderStatus';
import SendCustomNOtification from './SendCustomNOtification.jsx';
import BkashRefund from './BkashRefund';
import OrderNotes from './OrderNotes';
import { useOrderDetailsV4 } from '../../../requests/order.js';
import MultiVendorOrderDetails from './MultiVendorOrderDetails.jsx';
import AssignedRider from './AssignedRider.jsx';

const ContentBox = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: { margin: '16px' },
}));


const OrderDetailFragment = () => {
    const { id } = useParams();
    let { getOrderDetail } = useOrders();

    const [order, setOrder] = useState(undefined);
    const { data } = useOrderDetailsV4(id);
    const [packageExist, setPackageExist] = useState(false);

    useMemo(() => {
        if(data?.packages?.length > 0){
            if(data?.packages?.length > 0) {
                // take first package
                const firstPackage = data?.packages[0];
                if(firstPackage?.id){
                    setPackageExist(true);
                }
            }
        }
    }, [data]);
    


    async function loadData(){
        try {
            if (id !== undefined) {
                let orderRes = await getOrderDetail(id);
                if (orderRes !== null) {
                    setOrder(orderRes?.order);
                }
            }
        } catch (error) {
            console.log('error');
        }
    }

    useMemo(() => {
        loadData();
    }, [id]);


    if (order === undefined || !order) {
        return <MatxLoading />
    }

    return (
        <OrderProvider>
            <Fragment>
                <ContentBox className="analytics">
                    <Grid container spacing={3}>
                        <Grid item lg={8} md={8} sm={12} xs={12}>

                            {data && packageExist ? <>
                              {/* ********************************************** If Order is Multi Vendor then show New Style */}
                            <MultiVendorOrderDetails data={data} loadData={loadData} />
                            </>:<>
                            {/* *********************************************** IF Order is Single Vendor then show Previous Style */}
                            <OrderDetailTopCards order={order} loadData={loadData} />
                            <H4 sx={{ my: 2 }}>Order Products</H4>
                            <OrderItemsCards products={order?.products} orderId={order?.id} loadData={loadData} />
                            
                            </>}
                          
                            {/* Bkash Refund */}
                            <BkashRefund />
                            {/* <SendCustomNotification /> */}
                            <SendCustomNOtification />
                            {/*  Notes */}
                            <OrderNotes />


                        </Grid>

                        <Grid item lg={4} md={4} sm={12} xs={12}>
                            <OrderSummeryCard order={order} loadData={loadData} />
                            <br />
                            <AssignedRider order={order} />
                            <br />
                            <OrderStatus />
                            <br />
                            <OrderRiderSearchHistory />
                            <br />
                        </Grid>
                    </Grid>
                </ContentBox>
            </Fragment>
        </OrderProvider>
    );
};

export default React.memo(OrderDetailFragment);
